module.exports = __webpack_public_path__ + "static/img/Enon.c3f6ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Enon.png
// module id = wrMT
// module chunks = 1